export default "__VITE_ASSET__CcMrFazf__"